import {
  ALL_SUPPLIERS,
  GET_SUPPLIER_USERS,
  SUPPLIER_CREATED,
  SHOW_USER_FORM,
  UPDATE_VENDOR_USER,
  GET_DASH_SUPPLIERS,
  UPDATE_DASH_SUPPLIERS,
  CREATE_DASH_SUPPLIERS,
} from '../actionTypes';

const initalState = {
  dashSuppliers: [],
  totalDashSupplierUserPages: 0,
  suppliers: [],
  allUsers: [],
  showUserForm: false,
  totalSupplierUserPages: 0,
};

const SuppliersReducer = (state = initalState, action) => {
  switch (action.type) {
    case SHOW_USER_FORM: {
      return {
        ...state,
        showUserForm: action.payload,
      };
    }
    case ALL_SUPPLIERS: {
      return {
        ...state,
        allSuppliers: action.payload.suppliers,
      };
    }
    case SUPPLIER_CREATED: {
      const newUsers = [{ ...action.payload.data }];
      const users = [...newUsers, ...state.allUsers]
      const newCount = Math.ceil(users.length / action.payload.limit);
      return {
        ...state,
        showUserForm: false,
        totalSupplierUserPages: newCount,
        allUsers: [...users],
      }
    }
    case GET_SUPPLIER_USERS: {
      return {
        ...state,
        allUsers: action.payload.user,
        totalSupplierUserPages: action.payload.totalPages,
      };
    }
    case UPDATE_VENDOR_USER: {
      const users = [...state.allUsers]
      const { payload } = action
      const user = users.find((item) => item.id === payload.id)
      const ind = users.findIndex((item) => item.id === payload.id)
      const newUsers = [...users.slice(0, ind), { ...user, ...payload }, ...users.slice(ind + 1)]
      return {
        ...state,
        allUsers: [...newUsers],
      }
    }
    case GET_DASH_SUPPLIERS: {
      return {
        ...state,
        dashSuppliers: [...action.payload.user],
        totalDashSupplierUserPages: action.payload.totalPages,
      };
    }
    case UPDATE_DASH_SUPPLIERS: {
      const users = [...state.dashSuppliers]
      const { payload } = action
      const user = users.find((item) => item.id === payload.id)
      const ind = users.findIndex((item) => item.id === payload.id)
      const newUsers = [...users.slice(0, ind), { ...user, ...payload }, ...users.slice(ind + 1)]
      return {
        ...state,
        dashSuppliers: [...newUsers],
      }
    }
    case CREATE_DASH_SUPPLIERS: {
      const { data } = action.payload
      const users = [{ ...data }, ...state.dashSuppliers]
      const newCount = Math.ceil(users.length / action.payload.limit);
      return {
        ...state,
        showUserForm: false,
        totalDashSupplierUserPages: newCount,
        dashSuppliers: [...users],
      }
    }
    default:
      return state;
  }
};

export default SuppliersReducer;
